// extracted by mini-css-extract-plugin
export default {"container":"GroupBy_container__gVXPh","text":"GroupBy_text__6LTGV"};